import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilters = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.41828 13.6354H1.44922H7.41828Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.41828 13.6354H1.44922",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.0806 4.45298H16.0497H10.0806Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0806 4.45298H16.0497",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.89844 4.4017C5.89844 3.17425 4.89597 2.17894 3.65966 2.17894C2.42337 2.17894 1.4209 3.17425 1.4209 4.4017C1.4209 5.62917 2.42337 6.62448 3.65966 6.62448C4.89597 6.62448 5.89844 5.62917 5.89844 4.4017Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5791 13.5983C16.5791 12.3708 15.5774 11.3755 14.341 11.3755C13.104 11.3755 12.1016 12.3708 12.1016 13.5983C12.1016 14.8258 13.104 15.8211 14.341 15.8211C15.5774 15.8211 16.5791 14.8258 16.5791 13.5983Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFilters;
